import { client } from "../../../api/client"
export const fetchBannerByType = async (bannerType) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") { 
        return require('./_local/_bannerByTypeData.json')
    } else {
        const responseBanner = await client.get("campaigns/campaigns/" + bannerType)
        return responseBanner.data
    }
};